import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../store/AppContext.js';
import { Alert } from '../components/ui.js';

export function Unlock() {
  const { unlock, user, logout } = useApp();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await unlock(password);
      navigate('/vault');
    } catch {
      setError('Could not unlock — check your master password.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-wrap">
      <div className="panel auth-card">
        <div className="brand" style={{ padding: '0 0 18px' }}><span className="logo">🔐</span> Battini <span className="gradient-text">Vault</span></div>
        <h2 style={{ margin: '0 0 4px' }}>Unlock your vault</h2>
        <p className="muted" style={{ marginTop: 0, fontSize: 14 }}>Welcome back{user ? `, ${user.email}` : ''}. Enter your master password to decrypt locally.</p>
        {error && <Alert kind="error">{error}</Alert>}
        <form onSubmit={submit}>
          <div className="field">
            <label>Master password</label>
            <input type="password" autoComplete="current-password" autoFocus value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <button className="btn full" disabled={busy}>{busy ? 'Unlocking…' : 'Unlock'}</button>
        </form>
        <div className="mt" style={{ fontSize: 13 }}>
          <button className="ghost btn sm" onClick={() => logout()}>Sign out</button>
        </div>
      </div>
    </div>
  );
}
